import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppTabComponent } from 'src/app/components/tab/tab.component';
import { INDICATOR_TYPE } from 'src/app/shared/enums';
import { ITab } from 'src/app/shared/interfaces/ITab';
import { ProcessIndicatorDetailComponent } from '../process-indicator-detail/process-indicator-detail.component';
import { TablerIconComponent } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { ProcessGeneralInformationComponent } from '../process-general-information/process-general-information.component';
import { AuthService } from 'src/app/services/auth.service';
import { TableService } from 'src/app/services/table.service';
import { ROUTES } from 'src/app/shared/constants';

@Component({
  imports: [TranslateModule, AppTabComponent, TablerIconComponent, MaterialModule],
  templateUrl: './process-detail.component.html',
  standalone: true
})
export class ProcessDetailComponent implements OnInit {
  tabs!: ITab;
  allocationTypes: any[] = [];
  isReadOnly: boolean;
  indicators: any[] = [];
  process: any = {};

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private tableService: TableService,
    private authService: AuthService) {
    this.process.processId = +this.route.snapshot.parent?.params['processId'] || +this.route.snapshot.params['processId'];
    this.isReadOnly = this.router.url.startsWith('/admin');
  }

  ngOnInit(): void {
    this.initTabs();
  }

  initTabs() {
    const subTabClass = `
      [&_.mat-mdc-tab-labels_.mdc-tab]:rounded-md!
      [&_.mat-mdc-tab-labels_.mdc-tab]:h-[44px]!
      [&_.mdc-tab--active_.mdc-tab-indicator>span]:border-transparent!
      [&_.mdc-tab--active]:bg-[var(--mat-sys-primary-fixed-dim)]!
      dark:[&_.mdc-tab--active]:bg-[var(--mat-tab-active)]!
    `;
    this.tabs = {
      children: [
        {
          title: 'information',
          tabContent: {
            component: ProcessGeneralInformationComponent,
            inputs: {
              process: this.process
            }
          }
        }, 
        ...(this.isReadOnly || this.authService.userInfo?.hasPefDatabaseAccess ? [
          {
            title: 'Economic',
            children: {
              tabStyles: {
                class: subTabClass
              },
              children: [
                {
                  title: 'ReCiPe',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 1,
                      type: INDICATOR_TYPE.ReCiPe
                    }
                  }
                },
                {
                  title: 'EF3.1',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 1,
                      type: INDICATOR_TYPE.EF31
                    }
                  }
                }
              ]
            }
          },
          {
            title: 'Energy',
            children: {
              tabStyles: {
                class: subTabClass
              },
              children: [
                {
                  title: 'ReCiPe',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 2,
                      type: INDICATOR_TYPE.ReCiPe
                    }
                  }
                },
                {
                  title: 'EF3.1',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 2,
                      type: INDICATOR_TYPE.EF31
                    }
                  }
                }
              ]
            }
          },
          {
            title: 'Mass',
            children: {
              tabStyles: {
                class: subTabClass
              },
              children: [
                {
                  title: 'ReCiPe',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 3,
                      type: INDICATOR_TYPE.ReCiPe
                    }
                  }
                },
                {
                  title: 'EF3.1',
                  tabContent: {
                    component: ProcessIndicatorDetailComponent,
                    inputs: {
                      process: this.process,
                      allocationTypeId: 3,
                      type: INDICATOR_TYPE.EF31
                    }
                  }
                }
              ]
            }
          }
        ] : [])
      ]
    };
  }

  close() {
    this.tableService.markForRestore('process-table');
    this.router.navigate([!this.isReadOnly ? ROUTES.USER.PROCESS : ROUTES.ADMIN.PROCESS]);
  }
}
